/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef, ViewEncapsulation, ChangeDetectionStrategy } from "@angular/core";
import { CircleListItem } from "./cart-list.types";
import { CommonModule } from '@angular/common';
import { MibpTimeAgoComponent } from 'root/modules/home/modules/home-dashboard/components/time-ago/time-ago.component';
import { LoaderComponent } from 'root/shared/components/status/loader/loader.component';
import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';


@Component({
  selector: 'mibp-circle-list',
  templateUrl: './circle-list.component.html',
  styleUrls: ['./circle-list.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, MibpTimeAgoComponent, LoaderComponent, ResourceStringComponent]
})
export class MibpCircleListComponent {

  @Input() items: CircleListItem<any>[];
  @Input() isLoading = false;
  @Input() hasError = false;
  @Input() allowRetry = true;
  @Output() retry = new EventEmitter();

  @ContentChild(TemplateRef) templateRef: TemplateRef<any>;

  triggerRetry(): void {
    this.retry.emit();
  }

}
